import React from 'react'
import DatePicker from 'react-datepicker'

import './Calendar.scss'

// The only purpose of this component is to style the DatePicker
const Calendar = (props) => {
  return (
    <div className='Calendar'>
      <DatePicker {...props} />
    </div>
  )
}

Calendar.displayName = 'Calendar'
Calendar.propTypes = {}
Calendar.defaultProps = {}

export default Calendar



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/ServiceSetup/screens/DateTimeForm/components/DateSelector/components/CalendarDay/components/CalendarModal/components/Calendar/Calendar.js